export default __webpack_public_path__ + "static/media/greenCard.721926fa.png";